import styled from 'styled-components'
import { layout, typography, space, flexbox, color } from 'styled-system'
import { A, Input } from 'components/generic/HomePageComponents'

export const DirectoryWrapper = styled.div`
  background: ${(props) => props.theme.colors.lightGreyBackground};
`

export const ResultsCountH3 = styled.h3`
  padding-top: 0px;
  font-size: 24px;
  letter-spacing: 1.5px;
  line-height: 26.4px;
  margin-top: 20px;
  color: ${(props) => props.theme.colors.textColor};
`

export const StyledInput = styled(Input)`
  border: none;
  color: ${(props) => props.theme.colors.searchInputColor};
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
  padding-left: 10px;
  :focus {
    border-color: ${(props) => props.theme.colors.facetDropdownBorderColor};
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px rgba(102,175,233,0.6);
  }

`
export const StyledA = styled.a`
  width: 34px;
  height: 34px;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.secondary};
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${(props) => props.theme.colors.darkMainColor};
  }
`
export const HeroBannerContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: center;
  ${layout}
  ${space}
`
export const HeroBannerTitle = styled.h1`
  color: ${(props) => props.theme.colors.white};
  font-size: 32px;
  font-weight: bold;
  margin-top: 24px;
  margin-bottom: 24px;
  ${flexbox}
`

export const HeroBannerText = styled.p`
  display: block;
  color: ${(props) => props.theme.colors.white};
  font-size: 16px;
  font-weight: bold;
  padding: 8px 0px 0px;
  align-self: flex-start;
  ${flexbox}
`

export const HeroBannerButton = styled(A)`
  transition: background-color 0.5s ease;
  font-weight: bold;
  white-space: normal;
  text-decoration: none;
  border-radius: 5px;
  text-align: center;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textColor};
  box-shadow: 0 1px 5px rgba(0,0,0,0.4);
  padding: 8px 32px 8px;
  border: 2px solid;
  border-color: ${(props) => props.theme.colors.white};
  margin-bottom: 32px;
  align-self: flex-start;
  max-height: 42px;
  max-width: 246px;
  :hover {
    background-color: ${(props) => props.theme.colors.inverseColor};
    color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.white};
  }
  ${layout}
  ${typography}
  ${flexbox}
`

export const HeroBannerButtonText = styled.p`
  margin: 4px 0px;
`

export const PaginationContainer = styled.div`
  border-radius: 16px;
  font-weight: normal;
  cursor: pointer;
  overflow: hidden;
`

export const PaginationLeftButton = styled.div`
  display: inline-flex;
  border-bottom-left-radius: 50%;
  border-top-left-radius: 50%;
  color:  ${(props) => props.theme.colors.textColor};
  border-color: white;
  border: 1px right solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  text-decoration: none;
  ${color}
`

export const PaginationMiddleButton = styled.div`
  display: inline-flex;
  color:  ${(props) => props.theme.colors.textColor};
  border-color: white;
  border: 1px solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  ${color}
`

export const PaginationEllipsisButton = styled.div`
  display: inline-flex;
  color:  ${(props) => props.theme.colors.textColor};
  border-color: white;
  cursor: not-allowed;
  border: 1px solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  padding: 7px 10px 3px;
  text-decoration: none;
  ${color}
`

export const PaginationRightButton = styled.div`
  display: inline-flex;
  border-bottom-right-radius: 50%;
  border-top-right-radius: 50%;
  color:  ${(props) => props.theme.colors.textColor};
  border-color: white;
  border: 1px right solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  text-decoration: none;
  ${color}
`

export const PaginationAnchor = styled.a`
  padding: 7px 10px 3px;
  text-decoration: none;
`

export const StyledBreadCrumbs = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.inverseColor};
  cursor: pointer;
  margin-right: 8px;
  display: contents;
  font-size: 14px;
  :hover {
      text-decoration: underline;
      color: ${(props) => props.theme.colors.secondary};
    }
`

export const LoadingSkeleton = styled.div`
  display: block;
  margin-bottom: 16px;
  background: linear-gradient(-90deg, #ebebeb 0%, #f5f5f5 50%, #ebebeb 100%);
  background-size: 400% 400%;
  border-radius: 5px;
  animation: pulse 0.5s ease-in-out infinite;
  ${layout}
  ${space}
  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`

export const MainLoadingSkeleton = styled(LoadingSkeleton)`
  &::before {
    content: "\00a0";
  }
`

export const DirectoryLoadingSkeleton = styled(MainLoadingSkeleton)`
  background: linear-gradient(-90deg, #9c9c9c 0%, #f5f5f5 50%, #9c9c9c 100%);
`

export const SpaceAroundDiv = styled.div`
  justify-content: space-around;
  max-width: calc(100% - 20px);
  display: flex;
  ${flexbox}
`

export const AdContainerDiv = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.lightGreyBackground};

  div:empty {
    display: none;
    width: 0;
    height: 0;
  }
  ${layout}
  ${space}
`